




import { defineComponent } from '@vue/composition-api';
import { Route } from 'vue-router';
import storage from '@/renderer/scripts/utils/storage';
import { TeamPathInfo } from '@/renderer/scripts/utils/upload/types';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
export default defineComponent({
  beforeRouteEnter(to: Route, from: Route, next: Function) {
    const remote: any = storage.get(storage.StoreKey.REMOTE_PATH);
    const teamPathInfo: TeamPathInfo = storage.get(storage.StoreKey.TEAM_PATH);
    let query: Record<string, any> = {
      path: '',
    };
    if (from.name === 'logQuery') {
      query = {
        path: remote?.remoteFolder,
      };
    } else {
      query = {
        path: (remote?.folderPath || []).join('/'),
      };
    }
    const params: any = {};
    if (remote?.routerName === 'collaborationSpaceList') {
      query = {
        ...query,
        spaceId: remote?.spaceId,
        id: remote?.groupId,
        name: remote?.name,
        spaceOrgId: remote?.orgId,
      };
    } else if (remote?.routerName === 'teamSpace') {
      query = {
        ...query,
        spaceId: remote?.spaceId,
        teamId: remote?.id,
        teamPath: (teamPathInfo?.path || []).join('/'), // 团队空间存的path为teamPath
      };

      params.fromTransit = 1; // 团队空间用于赋值团队路径
    } else if (remote?.routerName === 'favoriteList') {
      query = {
        ...query,
        startIndex: (remote?.folderPath || []).length,
      };
    }

    next((vm: { $router: { replace: (arg0: { name: any; query: Record<string, any>; params: any }) => void } }) => {
      dispatchRouter(
        {
          name: remote?.routerName,
          query,
          params: { ...params },
        },
        'replace',
      );
    });
  },
});
